import { useState } from "react";
import {
  Checkbox,
  Table,
  TableBody,
  TableContainer,
} from "@mui/material";
import {
  CustomTableFooter,
  NoDataTable,
  StyledTableCell,
  StyledTableRow,
} from "../../../components";

interface Props {
  data: any;
}

function BaraGrouilleurTable({ data }: Props) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const items = (
    rowsPerPage > 0
      ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      : data
  );

  return (
    <TableContainer>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableBody>
          {items.map((item: any, index: any) => (
            <StyledTableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                cursor: "pointer",
              }}
            >
              <StyledTableCell><Checkbox /></StyledTableCell>
              <StyledTableCell>{`${item?.nom} ${item?.prenom}`}</StyledTableCell>
              <StyledTableCell>{item?.telephone}</StyledTableCell>
              <StyledTableCell>{item?.matricule}</StyledTableCell>
            </StyledTableRow>
          ))}
          {!items.length ? <NoDataTable /> : null}
        </TableBody>
        <CustomTableFooter
          rowsPerPage={rowsPerPage}
          data={data}
          page={page}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Table>
    </TableContainer>
  );
}

export default BaraGrouilleurTable;
